import React, { Fragment } from 'react'
import styles from './Analyze.scss'
import analyzeGraphic from './analyze-graphic.svg'
import { Card } from 'common/styleguide/Card'
import { CTA } from 'common/styleguide/CTA'
import { ColWrap } from 'common/layouts/SideNavLayout/TwoCol'
import { currentUserHasPrivilege, getCurrentUser } from 'lib/utils'
import { Msg, featureNames, commonCTAs } from 'lib/localization'
import Helmet from 'react-helmet'
import { FormattedMessage as T, injectIntl } from 'react-intl'

class _Analyze extends React.PureComponent {
  componentDidMount () {
    // if user can access ride center but somehow wound up here, redirect on mount!
    if (currentUserHasPrivilege('activity_center')) {
      window.location.href = `${window.location.origin}/activities`
    }
  }

  render () {
    return (
      <ColWrap>
        <Helmet title={`${this.props.intl.formatMessage(featureNames.analyze)} · Ride with GPS`} />
        <div>
          <h2 data-heading-alt><Msg m={featureNames.analyze} /></h2>
          <Card className={styles.card}>
            <img className={styles.graphic} src={analyzeGraphic} alt='ride analysis symbol' />
            <h1 data-heading-alt><T id='Analyze.yourRides' defaultMessage='Analyze Your Rides' /></h1>
            <div className={styles.leadText}>
              <h2>
                <T id='Analyze.premiumSubscribers' defaultMessage='Premium subscribers can access the Ride Center to analyze rides and manage ride data in bulk.' />
              </h2>
            </div>
            <CTA inline primary href='https://ridewithgps.com/help/ride-center' target='_blank' margins={false}><Msg m={commonCTAs.learnMore} /></CTA>
            {getCurrentUser().eligibleForOnetimeTrial && <Fragment>
              <div className={styles.trialText}>
                <h2>
                  <T id='Analyze.trialInterest' defaultMessage='Interested in a 7 day trial of all Premium features?' />
                </h2>
              </div>
              <CTA inline secondary href='/subscriptions/new?account_level=premium&trial=1' margins={false}><Msg m={commonCTAs.startFreeTrial} /></CTA>
            </Fragment>}
          </Card>
        </div>
      </ColWrap>
    )
  }
}

export const Analyze = injectIntl(_Analyze)
